import BaseService from './base-service.js'

export default {
    async boLogin(loginData) {
        const { data } = await BaseService.post('/auth/boLogin', loginData)
        return data
    },
}
